import { accessAreaBranches } from "@/constants/area-constants";
import { FC, useState } from "react";
import RightArrowIcon from "./RightArrowIcons";

export type TreeHierarchy = {
    name: string;
    value?: boolean;
    label: string;
    image?: string;
    options: TreeHierarchy[];
    parent?: TreeHierarchy;
    id?: string;
    branch?: string;
    checked?: boolean;
    parentId?: number;
    areaLocationId?: string; // we need it for deleting Location
}

interface CheckboxNodeFieldProps {
    node: TreeHierarchy,
    compact: boolean,
    collapse?: boolean,
    onCheck?: (node: TreeHierarchy, fieldValues?) => void
    onToggleExpand?: (node: TreeHierarchy) => void,
    removeCheckBox?: boolean
}

export const CheckboxNodeField: FC<CheckboxNodeFieldProps> = ({ node,
    compact = true,
    onToggleExpand,
    onCheck,
    collapse = true,
    removeCheckBox = false
}) => {
    const [collapsed, setCollapsed] = useState(collapse);
    const [expand, setExpand] = useState(false)

    const onExpand = () => {
        setExpand(exp => !exp);

        if (onToggleExpand) {
            onToggleExpand(node);
        }
        setCollapsed(!collapsed)
    }

    return (<div className="border-l">
        <div className="flex">
            <div className={`${node.options ? "" : "invisible"}`}>
                <RightArrowIcon expand={expand} handleExpand={onExpand} hasNoNode={node.branch === accessAreaBranches.LOCATION} />
            </div>
            {!removeCheckBox && <input type="checkbox" className="ml-1 mr-3" onChange={() => {
                onCheck && onCheck(node)
            }} checked={node.checked} />}
            <span>{node?.label}</span>
        </div>
        {collapsed
            ? null
            : node?.options?.map((option, i) => (
                <div key={`${node.name}/${i}`} className="ml-3">
                    <CheckboxNodeField key={`${i}`} node={option} compact={compact} onCheck={onCheck} onToggleExpand={onToggleExpand}></CheckboxNodeField>
                </div>
            ))}
    </div>)
}
